module.exports = __webpack_public_path__ + "img/newlogo_white.b6d44e16.png";